module.exports = __webpack_public_path__ + "img/outline-insert-comment.4a0a3f6b.svg";